<template>
  <div id="app" :class="theme+'-theme'">

    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
}
</script>
<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/* 全局主题变量 */
#app.light-theme {
  /* 颜色定义 */
  --header-icon-color: #33333e;
  --warning-icon-color: #bc5871;
  --bottom-icon-color: #7f7e7e;
  --bottom-icon-active-color: #97c9f9;
  --text-color: #7F7E7E;
  --footer-bg: #FFFFFF;

  /* 滑块相关 */
  --slider-bg: #7F7E7E;
  --slider-fill: #fcfcfc;
}

#app.dark-theme {
  /* 颜色定义 */
  --header-icon-color: #ffffff;
  --warning-icon-color: #f7e707;
  --bottom-icon-color: #ffffff;
  --bottom-icon-active-color: #f7e707;
  --text-color: #FFFFFF;
  --footer-bg: #707070;

  /* 滑块相关 */
  --slider-bg: #7F7E7E;
  --slider-fill: #f7e707;
}
</style>
